import { apiAdminPaths, apiPaths, customerApiBase } from "enum/paths.enum";
import {
  CarrierOutageBannerColor,
  ICarrierOutageBanner,
} from "models/carrierOutageBanner/carrierOutageBanner.model";
import { ISalesAccount } from "models/salesAccount/salesAccount.model";
import { fetcher, IFetchResponseSingle } from "services/api";
import { fetchSingle } from "services/get";
import { post } from "services/post";
import { put } from "services/put";

// Create and edit both send the whole banner.
export interface CarrierOutageBannerPayload {
  isActive: boolean;
  text: string;
  color: CarrierOutageBannerColor;
  salesAccountIds: number[];
}

/** The switched-on banners that list this account, oldest first. */
export const fetchCarrierOutageBanners = async (
  salesAccountUUID: ISalesAccount["uuid"]
): Promise<
  IFetchResponseSingle<{
    banners: { id: number; text: string; color: CarrierOutageBannerColor }[];
  }>
> =>
  await fetchSingle(
    `${customerApiBase}/${salesAccountUUID}${apiPaths.carrierOutageBanners}`
  );

/** The X on a banner: hides it for everyone on this account. */
export const hideCarrierOutageBanner = async (
  salesAccountUUID: ISalesAccount["uuid"],
  id: number
) =>
  await post<{ id: number }>(
    `${customerApiBase}/${salesAccountUUID}${apiPaths.carrierOutageBanners}/${id}/hide`
  );

export const fetchAdminCarrierOutageBanners = async (): Promise<
  IFetchResponseSingle<ICarrierOutageBanner[]>
> => await fetchSingle(apiAdminPaths.carrierOutageBanners);

export const createCarrierOutageBanner = async (
  payload: CarrierOutageBannerPayload
) =>
  await post<ICarrierOutageBanner>(apiAdminPaths.carrierOutageBanners, payload);

export const updateCarrierOutageBanner = async (
  id: ICarrierOutageBanner["id"],
  payload: CarrierOutageBannerPayload
) =>
  await put<ICarrierOutageBanner>(
    `${apiAdminPaths.carrierOutageBanners}/${id}`,
    payload
  );

export const deleteCarrierOutageBanner = async (
  id: ICarrierOutageBanner["id"]
): Promise<IFetchResponseSingle<{ id: number }>> =>
  (await fetcher<{ id: number }>({
    url: `${apiAdminPaths.carrierOutageBanners}/${id}`,
    method: "DELETE",
  })) as IFetchResponseSingle<{ id: number }>;
